import { FileSpreadsheet, IdCardLanyard, Network, Server, ShieldCheck, UserRound } from "lucide-react";

const mfaRadiusNavigation = [
  {
    key: "/pam/directory",
    icon: <IdCardLanyard className="icon" />,
    label: "Identity Sources",
    navigate: "/pam/directory",
  },
  {
    key: "/pam/users",
    icon: <UserRound className="icon" />,
    label: "Users",
    navigate: "/pam/users",
  },
  // The FreeRADIUS servers running the AuthNull bridge, and their heartbeat (was the
  // "Connect FreeRADIUS" page at /pam/radius/onboard, which redirects here).
  {
    key: "/pam/radius/servers",
    icon: <Server className="icon" />,
    label: "RADIUS Servers",
    navigate: "/pam/radius/servers",
  },
  {
    key: "/pam/radius",
    icon: <Network className="icon" />,
    label: "Network Devices",
    navigate: "/pam/radius",
  },
  {
    key: "/pam/policies/radius",
    icon: <FileSpreadsheet className="icon" />,
    label: "Policies",
    navigate: "/pam/policies/radius",
  },
  // Old policy logs page — hidden from the Radius sidebar (still reachable via /pam/policy-logs URL).
  // {
  //   key: "/pam/policy-logs",
  //   icon: <ScrollText className="icon" />,
  //   label: "Logs(old)",
  //   navigate: "/pam/policy-logs",
  // },
  // OLD: the shared AD log page, which lists AD (Kerberos / NTLM) events under a "Radius" title.
  // {
  //   key: "/pam/auth-logs",
  //   icon: <ShieldCheck className="icon" />,
  //   label: "Logs",
  //   navigate: "/pam/auth-logs",
  // },
  {
    key: "/pam/radius/logs",
    icon: <ShieldCheck className="icon" />,
    label: "Logs",
    navigate: "/pam/radius/logs",
  },
];

export default mfaRadiusNavigation;
